// extracted by mini-css-extract-plugin
export default {"item-download":"MenuDrawer_item-download__gBuGa","img-social":"MenuDrawer_img-social__te46p"};